<template>
    <app-dialog
        v-model="isActive"
        :overline="$t('security')"
        :title="$t('session_expired')"
        :text="$t('your_account_was_automatically_logged_out')"
        persistent
        size="medium"
        hide-cancel-button
        :continue-button-text="$t('log_back_in')"
        :on-continue-fn="() => login()"
        :hide-on-continue="false"
    />
</template>

<script>
export default {
    name: 'AppSessionExpired',
    components: {
        AppDialog: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/AppDialog'
            )
    },
    props: {
        value: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        //
    }),
    computed: {
        isActive: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    methods: {
        async login() {
            const newTab = this.$route.name !== 'InvestorOnboarding';
            await this.Auth().login(newTab);
        }
    }
};
</script>
